<template>
  <v-card-text>
    <v-alert type="success">恭喜您已经注册成功!</v-alert>
    <v-col>
      <v-row class="mb-2" align="center" justify="center">
        <v-avatar color="orange" size="100">
          <img
            src="https://images.unsplash.com/photo-1534342357876-491359270a66?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60"
            alt="avatar"
          />
        </v-avatar>
      </v-row>
      <v-row class="mb-2" align="center" justify="center">
        <h2 class="mr-3">体验账号:{{username}}</h2>
        <v-btn outlined color="primary" v-clipboard:copy="username" v-clipboard:success="onCopy">复制</v-btn>
      </v-row>
      <v-row class="mb-2" align="center" justify="center">
        <h2>密码:{{password}}</h2>
      </v-row>
      <v-row class="mb-4" align="center" justify="center" style="color: red">
        注意：最终可操作且有效的账号密码会通过服务号的形式发放
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on">mdi-help-circle-outline</v-icon>
          </template>
          我是提示消息o(*￣▽￣*)o
        </v-tooltip>
      </v-row>
      <v-row class="mb-2" align="center" justify="center">
        <v-col>
          <v-img height="125" contain src="./image/u99.png"></v-img>
          <h4 align="center">扫码关注服务号</h4>
        </v-col>
        <v-col>
          <v-img height="125" contain src="./image/u99.png"></v-img>
          <h4 align="center">欢迎关注微钢小程序，获取不锈钢的最新资讯</h4>
        </v-col>
      </v-row>
    </v-col>
    <v-snackbar v-model="snackbar" timeout="2000">
      复制成功，赶紧去登录吧
      <template v-slot:action="{ attrs }">
        <v-btn color="pink" text v-bind="attrs" @click="snackbar = false">关闭</v-btn>
      </template>
    </v-snackbar>
  </v-card-text>
</template>

<script>
export default {
  data: () => {
    return {
      username: "213123",
      password: "123123",
      snackbar: false,
    };
  },
  methods: {
    onCopy() {
      this.snackbar = true;
    }
  }
};
</script>

<style scoped>
</style>